<script setup>
// Inspector do nó "Reserva Omnibees" (Fase 0): guarda a URL do motor de
// reservas do hotel + idioma/chain. O agente chama o tool `gerar_link_reserva`
// que monta o deep-link com datas/ocupação pré-preenchidas.
import { useI18n } from 'vue-i18n';

defineProps({ data: { type: Object, required: true } });
const emit = defineEmits(['update', 'remove', 'close']);
const { t } = useI18n();

const LANGS = [
  { value: 'pt-BR', label: 'Português (BR)' },
  { value: 'pt-PT', label: 'Português (PT)' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
];
</script>

<template>
  <div class="p-4">
    <div class="mb-3 flex items-center justify-between">
      <div class="flex items-center gap-2.5">
        <span
          class="flex size-8 shrink-0 items-center justify-center rounded-xl bg-n-teal-3 text-n-teal-11"
        >
          <span class="i-lucide-bed-double text-base" />
        </span>
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ data.label || t('AI_AGENTS.FLOW.BOOKING.TITLE') }}
        </h3>
      </div>
      <button class="i-lucide-x text-n-slate-10" @click="emit('close')" />
    </div>

    <div class="mb-3 rounded-lg border border-n-weak bg-n-alpha-1 p-3">
      <p class="text-sm text-n-slate-12">
        {{ t('AI_AGENTS.FLOW.BOOKING.DESC') }}
      </p>
    </div>

    <!-- Liga/desliga -->
    <label
      class="mb-3 flex cursor-pointer items-center justify-between rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2.5"
    >
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('AI_AGENTS.FLOW.TOOLS.ENABLED') }}
      </span>
      <input
        type="checkbox"
        class="size-4 shrink-0 accent-[#00897b]"
        :checked="data.enabled !== false"
        @change="emit('update', { enabled: $event.target.checked })"
      />
    </label>

    <!-- URL do motor de reservas -->
    <label class="mb-1 block text-xs font-medium text-n-slate-11">
      {{ t('AI_AGENTS.FLOW.BOOKING.URL_LABEL') }}
    </label>
    <input
      type="text"
      :value="data.bookingUrl || ''"
      :placeholder="t('AI_AGENTS.FLOW.BOOKING.URL_PH')"
      class="w-full rounded-lg border border-n-weak bg-n-solid-2 px-3 py-2 text-sm text-n-slate-12"
      @input="emit('update', { bookingUrl: $event.target.value })"
    />
    <p class="mt-1 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.BOOKING.URL_HINT') }}
    </p>

    <!-- Idioma -->
    <label class="mb-1 mt-3 block text-xs font-medium text-n-slate-11">
      {{ t('AI_AGENTS.FLOW.BOOKING.LANG_LABEL') }}
    </label>
    <select
      :value="data.lang || 'pt-BR'"
      class="w-full rounded-lg border border-n-weak bg-n-solid-2 px-3 py-2 text-sm text-n-slate-12"
      @change="emit('update', { lang: $event.target.value })"
    >
      <option v-for="l in LANGS" :key="l.value" :value="l.value">
        {{ l.label }}
      </option>
    </select>

    <!-- Chain ID (opcional) -->
    <label class="mb-1 mt-3 block text-xs font-medium text-n-slate-11">
      {{ t('AI_AGENTS.FLOW.BOOKING.CHAIN_LABEL') }}
    </label>
    <input
      type="text"
      :value="data.chainId || ''"
      :placeholder="t('AI_AGENTS.FLOW.BOOKING.CHAIN_PH')"
      class="w-full rounded-lg border border-n-weak bg-n-solid-2 px-3 py-2 text-sm text-n-slate-12"
      @input="emit('update', { chainId: $event.target.value })"
    />

    <button
      class="mt-4 w-full rounded-lg border border-n-ruby-7 py-2 text-sm font-medium text-n-ruby-9 hover:bg-n-ruby-3"
      @click="emit('remove')"
    >
      {{ t('AI_AGENTS.FLOW.REMOVE_NODE') }}
    </button>
  </div>
</template>
